import { buildRuntimeState, RuntimeSlice } from '@/store/slices/runtime/types';

export type { RuntimeSlice, RuntimeState } from '@/store/slices/runtime/types';

export const runtimeSlice = (): RuntimeSlice => ({
  runtime: buildRuntimeState(),
});
